import { Download, Lock } from 'lucide-react';
import type { PropertyFileResponse } from '@/shared/api';
import { formatDate } from '@/shared/lib/format';

/**
 * Auto-abgelegte Ausgangs-Rechnungen (System-generiert). Read-only: Vorschau +
 * Herunterladen, KEIN Löschen/Bearbeiten — sie hängen an einer Invoice-Entität und
 * dürfen nicht aus der Akte heraus verwaist werden.
 */
export function AusgehendInvoicesList({
  files,
  onPreview,
  onDownload,
}: {
  files: PropertyFileResponse[];
  onPreview: (f: PropertyFileResponse) => void;
  onDownload: (f: PropertyFileResponse) => void;
}) {
  return (
    <div>
      <p className="text-ink-soft mb-1 text-[11px] font-semibold uppercase tracking-[0.12em]">
        Ausgangsrechnungen — automatisch abgelegt
      </p>
      <p className="text-ink-faint mb-2 flex items-center gap-1.5 text-xs">
        <Lock size={12} className="shrink-0" />
        Gesperrte Belege: sie gehören zu einer Rechnung und lassen sich hier nicht ändern.
      </p>
      <ul className="space-y-0.5">
        {files.map((f) => (
          <li key={f.id} className="hover:bg-card-alt/50 flex items-center gap-2 rounded px-2">
            <button
              type="button"
              onClick={() => onPreview(f)}
              className="text-ink hover:text-sage flex min-h-11 min-w-0 flex-1 items-center gap-2 truncate text-left transition-colors"
              title={`${f.fileName} — Vorschau`}
            >
              <span className="min-w-0 truncate">{f.fileName}</span>
            </button>
            {f.issuedOn && (
              <span className="text-ink-faint shrink-0 text-sm tabular-nums">
                {formatDate(f.issuedOn)}
              </span>
            )}
            {/* Vorher hover-only und damit auf Touch unerreichbar (§9). */}
            <button
              type="button"
              onClick={() => onDownload(f)}
              aria-label={`${f.fileName} herunterladen`}
              title="Herunterladen"
              className="text-ink-faint hover:text-ink flex h-11 w-11 shrink-0 items-center justify-center rounded transition-colors"
            >
              <Download size={15} strokeWidth={2} />
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
